import React, { useEffect, useState } from 'react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth-config';

/* ---------- instância MSAL única (singleton) ---------- */
const pca = new PublicClientApplication(msalConfig);

/**
 * MsalAuthProvider
 * 1. Inicializa o cache do MSAL
 * 2. Processa o redirect (handleRedirectPromise)
 * 3. Define a primeira conta como ativa
 * 4. Exibe loader até que tudo esteja pronto
 */
export function MsalAuthProvider({ children }) {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cbId;

    async function boot() {
      try {
        /* 1) inicia + trata o redirect   */
        await pca.initialize();
        await pca.handleRedirectPromise();

        /* 2) define conta ativa, se houver */
        const accounts = pca.getAllAccounts();
        if (accounts.length && !pca.getActiveAccount()) {
          pca.setActiveAccount(accounts[0]);
        }

        /* 3) sincroniza entre abas        */
        pca.enableAccountStorageEvents();

        /* 4) mantém activeAccount após LOGIN_SUCCESS */
        cbId = pca.addEventCallback((ev) => {
          if (ev.eventType === EventType.LOGIN_SUCCESS && ev.payload?.account) {
            pca.setActiveAccount(ev.payload.account);
          }
        });

        setReady(true);
      } catch (e) {
        console.error('[MSAL] Falha ao inicializar', e);
        setError(e);
      }
    }

    boot();
    return () => cbId && pca.removeEventCallback(cbId);
  }, []);

  /* ---------- estados de UI ---------- */
  if (error) {
    return (
      <div className="text-center mt-5 text-danger">
        Erro na autenticação: {error.message}
      </div>
    );
  }

  if (!ready) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        Carregando…
      </div>
    );
  }

  /* ---------- provider MSAL pronto ---------- */
  return <MsalProvider instance={pca}>{children}</MsalProvider>;
}

/* Hook de conveniência (opcional) */
export const useMsalAuthProvider = () => ({ MsalAuthProvider });
